import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { SignIn, ArrowLeft } from "@phosphor-icons/react";
import { api } from "../lib/api";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { usePageMeta } from "../hooks/usePageMeta";

export default function AdminLoginPage() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    usePageMeta("Admin Login | GoMedVoyage", "GoMedVoyage team login.");

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            const { data } = await api.post("/auth/login", { email, password });
            localStorage.setItem("gmv_token", data.token);
            navigate("/admin");
        } catch (err) {
            const detail = err.response?.data?.detail;
            setError(typeof detail === "string" ? detail : "Login failed. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div data-testid="admin-login-page" className="min-h-screen bg-tint-slate flex items-center justify-center px-6">
            <div className="w-full max-w-md">
                <div className="rounded-3xl border border-slate-100 bg-white p-10 shadow-[0_16px_48px_rgb(10,37,64,0.08)]">
                    <img src="/images/logo.png" alt="GoMedVoyage" className="h-10 w-auto" />
                    <h1 className="mt-8 font-heading text-2xl font-semibold text-brand-blue">Team Login</h1>
                    <p className="mt-2 text-sm text-slate-500">Access the inquiries dashboard.</p>
                    <form onSubmit={submit} className="mt-8 space-y-5">
                        <div className="space-y-2">
                            <Label htmlFor="admin-email">Email</Label>
                            <Input data-testid="admin-email-input" id="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-xl h-12" placeholder="admin@gomedvoyage.com" />
                        </div>
                        <div className="space-y-2">
                            <Label htmlFor="admin-password">Password</Label>
                            <Input data-testid="admin-password-input" id="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-xl h-12" placeholder="••••••••" />
                        </div>
                        {error && (
                            <p data-testid="admin-login-error" className="text-sm text-red-600 bg-red-50 rounded-xl px-4 py-3">{error}</p>
                        )}
                        <button
                            data-testid="admin-login-submit"
                            type="submit"
                            disabled={loading}
                            className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-brand-blue px-8 py-3.5 text-sm font-semibold text-white hover:bg-brand-blue-light active:scale-95 disabled:opacity-60 transition-[background-color,transform] duration-200"
                        >
                            <SignIn size={16} weight="bold" />
                            {loading ? "Signing in…" : "Sign In"}
                        </button>
                    </form>
                </div>
                <Link to="/" data-testid="admin-back-home" className="mt-6 inline-flex items-center gap-2 text-sm text-slate-500 hover:text-brand-blue transition-colors">
                    <ArrowLeft size={14} /> Back to website
                </Link>
            </div>
        </div>
    );
}
